import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['SM', 'Sofía M.', 'Buenos Aires', 'Por primera vez pudimos hablar de un tema sin que terminara en pelea. Sentí que me escuchaba.'], ['PL', 'Patricia L.', 'Córdoba', 'Tenía las herramientas para conversar sin sonar como si le estuviera imponiendo nada.'], ['LS', 'Lorena S.', 'Rosario', 'Los acuerdos que hicimos hace dos semanas siguen funcionando. No se olvida todo como antes.'], ['MR', 'Marisa R.', 'Mendoza', 'Sé cómo prepararme antes de hablar. Llego más tranquila y eso cambia todo el tono de la conversación.']] as const;
const extended = [['Sofía M.', 'Buenos Aires', '“Pudimos hablar de algo importante sin que terminara en pelea. Por primera vez sentí que realmente me escuchaba.”'], ['Patricia L.', 'Córdoba', '“Tenía las herramientas para plantear una propuesta sin sonar como si le estuviera imponiendo nada.”'], ['Lorena S.', 'Rosario', '“Los acuerdos que hicimos hace dos semanas siguen funcionando. No se olvida todo como antes.”'], ['Marisa R.', 'Mendoza', '“Sé cómo prepararme antes de hablar. Llego más tranquila y eso cambia todo el tono de la conversación.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="1qd56pssj5b5k">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-171" data-mp="1zbqmxhaj4e36" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+580', 'cuidadoras ya usando el kit'], ['3', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-172" data-mp="2e14zszdbddnb">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-173" data-mp="2i2qgkvsyyc2s">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-174" data-mp="2n2ctf44vxqb2">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-175" data-mp="mz1vwcjqz8ti">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-176" data-mp="mwz4pp6uz9n7">
                {label}
              </p>
            </div>)}
        </div>
      </section>
      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-177" data-mp="wqy78paugvfo">
        <div className="mx-auto max-w-6xl" data-id="element-178" data-mp="rxd4yl27xfao">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-179" data-mp="rwbscc5k0kqu">
            💬 LO QUE DICEN LAS CUIDADORAS
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-180" data-mp="11ng7bbv8c5lo">
            {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-181" data-mp="1aow76pof4pbn" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-182" data-mp="1s01sawrxocne">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-183" data-mp="1ww0ag2mo4yfd">
                    {initials}
                  </div>
                  <div data-id="element-184" data-mp="1n670t7636tdr">
                    <h3 className="font-bold" data-id="element-185" data-mp="1n5feyo2aka0o">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-186" data-mp="196xseto4h3kc">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-187" data-mp="1e7ljtgg9jmf3">
                  <Stars data-id="element-188" data-mp="1e4h7fvsn9kdc" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-189" data-mp="107kkw6jk6p29">“{quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-190" data-mp="2ullgmijtavy4">
      <div className="mx-auto max-w-5xl" data-id="element-191" data-mp="2ylvmlv7ltmcz">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-192" data-mp="29vrajuo23o21">
          LO QUE DICEN LAS CUIDADORAS
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-193" data-mp="24x7olu9gqc9o">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-194" data-mp="1zw0jk2ypfr6p">
              <Stars data-id="element-195" data-mp="1uxp6ljd450k9" />
              <p className="mt-2 font-bold" data-id="element-196" data-mp="1uy8r97u5e31z">
                {name} <span className="font-normal text-slate-400" data-id="element-197" data-mp="1qxeyo15rg02r">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-198" data-mp="1m5na1w6604f9">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}